import LegalPage from "../Components/LegalPage.js";

export function PrivacyPolicy() {
  return <LegalPage bodyKey="legal.privacy.body" />;
}
